module.exports = __webpack_public_path__ + "static/media/avatar4.97e92e0f.jpeg";